import { React } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import { ReactComponent as SearchIcon } from '../../image/Searching.svg';

export default function SearchInput(props) {
  const { value, setValue, placeholder } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  function handleChange(e) {
    setValue(e.target.value);
  }

  return (
    <TopLevelWrapper>
      <SearchSvg />
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
	height: 32px;

  border-radius: 16px;
  background-color: ${props => props.theme.buttonFill};
`;

const SearchSvg = styled(SearchIcon)`
  margin: 0px 8px 0px 8px;

  width: 24px;
  height: 24px;

  & path {
    fill: ${props => props.theme.subText};
  }
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

	outline: none;
	border: 0px;
  color: ${props => props.theme.text};

	width: 320px;
	height: 100%;

  background-color: transparent;

	::placeholder {
		color: ${props => props.theme.line};
	}

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${props => props.theme.scrollBar};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${props => props.theme.subBackground};
  }
`;
